import S from "./index.module.scss";
import SShared from "../shared.module.scss";

const ServiceContacts = () => {
  return (
    <div className={SShared.mainWrapper}>
      <div className={SShared.topContent}>
        <h2 className={SShared.slogan}>097 485 67 87</h2>
        <p className={S.description}>
          ПН–ЧТ 09:00–17:00 <br /> ПТ 09:00–16:00
          <br /> СБ-Нед та святкові дні — вихідний
        </p>
      </div>
    </div>
  );
};

export default ServiceContacts;
